import Rellax from "rellax";

function rellax() {
  var rellax = new Rellax(".rellax", {
    center: true,
    speed: 2,
  });

  window.addEventListener("load", () => {
    rellax.refresh();
  });
}

export default rellax;
